(() => {
  const sectionId = document.currentScript.getAttribute("data-section-id");
  const section = sectionId == undefined ? (document.querySelector(`#${sectionId}`) ?? document) : document;
  const links = section.querySelectorAll(".size-guide-page__links a");

  const linkIdMap = new Map();
  for (const l of links) {
    const targetId = l.getAttribute("data-target");
    if (!targetId) {
      console.warn("size guide link does not have data-target id", { link: l });
    } else {
      linkIdMap.set(targetId, l);
    }
  }

  const scrollToWithOffset = (targetElem) => {
    const navbarHeight = 200;

    const targetHeight = targetElem !== undefined 
      ? targetElem.getBoundingClientRect().top + window.pageYOffset - navbarHeight
      : 0;

    scrollTo({
      top: targetHeight,
      left: 0,
      behavior: "smooth",
    });
  };

  const onLinkClick = (scrollToTop) => (ev) => {
    ev.preventDefault();

    const targetId = ev.target.getAttribute("data-target");
    if (targetId === undefined) {
      console.error("anchor does not have data-target attribute", { anchor: ev.target });
      return;
    }

    const targetElem = section.querySelector(`#${targetId}`);
    if (targetElem === undefined) {
      console.error("anchor does not link to valid element in section", { anchor: ev.target, targetId: targetId, target: targetElem });
      return;
    }

    targetElem.focus({
      preventScroll: true,
    });

    if (scrollToTop) {
      scrollToWithOffset(undefined);
    } else {
      scrollToWithOffset(targetElem);
    }
  };

  const initLinks = () => {
    let idx = 0;
    for (const l of links) {
      l.addEventListener("click", onLinkClick(idx == 0));
      idx++;
    }
  };

  const pageIntersectionCallback = (entries, observer) => {
    for (const e of entries) {
      const matchingLink = linkIdMap.get(e.target.id);
      if (!matchingLink) {
        console.warn("intersection entry does not map to a link", { target: e.target, id: e.target.id, linkIdMap });
        continue;
      }

      matchingLink.classList.toggle("size-guide-page__link--visible", e.isIntersecting);
    }
  };

  const onTblScroll = (event) => {
    const border = event.target.scrollLeft > 0.5 ? "var(--neutral-200)" : "transparent";
    for (const header of event.target.querySelectorAll("th")) {
      header.style.borderColor = border;
    }
  };

  const buildThresholdList = (numSteps) => {
    const thresholds = [];

    for (let i = 1.0; i <= numSteps; i++) {
      const ratio = i / numSteps;
      thresholds.push(ratio);
    }

    thresholds.push(0);
    return thresholds;
  }

  const initPages = () => {
    console.log(buildThresholdList(10))
    const options = {
      root: document,
      rootMargin: "-140px 0px -100px -300px",
      scrollMargin: "0px",
      thresholds: buildThresholdList(10)
    };

    const observer = new IntersectionObserver(pageIntersectionCallback, options);

    const sizeGuides = section.querySelectorAll(".size-guide");
    for (const sg of sizeGuides) {
      observer.observe(sg);
    }

    for (const tbl of section.querySelectorAll(".size-guide__table-wrapper")) {
      tbl.addEventListener("scroll", onTblScroll);
    }
  };

  const initSuitsSplide = () => {
    const tabs = section.querySelectorAll(".size-guide__suit-fit-tab");

    const splide = new Splide(".size-guide__suits-carousel", {
      label: "Suit size tables",
      type: "fade",
      rewind: true,
      arrows: false,
      pagination: false,
      drag: false,
      wheel: false,
      keyboard: false,
    });

    const setActiveTab = (newIdx) => {
      for (let i = 0; i < tabs.length; i++) {
        const isActive = i === newIdx;
        tabs[i].classList.toggle("size-guide__suit-fit-tab--active", isActive);
        tabs[i].setAttribute("aria-selected", String(isActive));
      }
    };

    splide.on("moved", (newIdx) => setActiveTab(newIdx));

    for (let i = 0; i < tabs.length; i++) {
      tabs[i].addEventListener("click", () => splide.go(i));
    }

    splide.mount();
  };

  initLinks();
  initPages();
  initSuitsSplide();
})();
